// extracted by mini-css-extract-plugin
export default {"content":"styles_content__eyrZs","detailsLink":"styles_detailsLink__-2mK4"};